<h1 class="page-title">County Spending Report</h1>
<section class="widget">
    <div class="widget-body p-5">
        <div class="mb-lg">
            <div [formGroup]="form">

                <div class="row">

                    <div class="col-md-6 custom-multiple-select-wrapper">
                        <label>Fund Type</label>
                        <ng-select
                            [items]="fundTypes"
                            bindLabel="displayName"
                            bindValue="id"
                            [multiple]="true"
                            [closeOnSelect]="false"
                            [formControl]="selectedFundTypeIds"
                            placeholder="-- Filter By Fund Type (All if empty) --"
                            >
                        </ng-select>
                    </div>
                    <div class="col-md-6">
                        <label>County</label>
                        <select [formControl]="countyName" class="form-control form-select">
                            <option value="allCounties">All Counties</option>
                            <option *ngFor="let county of counties"
                                    [value]="county.name">{{county.displayName}}</option>
                        </select>
                    </div>
                </div>
                <div class="display-flex flex-row w-100 justify-content-end my-3 me-2">
                    <a [href]="downloadReport()" class="btn btn-primary me-2">Export to Excel</a>
                    <button type="button" (click)="filterCounties()" class="btn btn-primary me-2">Submit</button>
                    <button type="button" (click)="clearFilters()" class="btn btn-secondary">Clear Filters</button>
                </div>
            </div>

            <table-dynamic id="datatable-table"
                           class="table table-striped table-hover"
                           [headers]="tableHeaders"
                           [tableClass]="'block-scroll-x'"
                           [currentPage]="currentPage"
                           [totalCount]="totalCount"
                           (headerClick)="sortCounties($event)"
                           (pageChanged)="setPage($event)"
                           (limitChange)="setLimit($event)">
                <tr *ngFor="let county of (countySpending$ | async)?.items">
                    <td class="hidden-sm-down">{{ county.countyName }}</td>
                    <td class="hidden-sm-down">{{ county.pledgesInProgressTotal }}</td>
                    <td class="hidden-sm-down">{{ county.pledgesPaidTotal }}</td>
                    <td class="hidden-sm-down">{{ county.pledgeDollarsTotal | currency }}</td>
                    <td class="hidden-sm-down">{{ county.pledgesUnprocessedTotal | currency }}</td>
                    <td class="hidden-sm-down">{{ county.pledgesApplicationsTotal }}</td>
                </tr>
            </table-dynamic>
        </div>
    </div>
</section>
